import { createFileRoute } from '@tanstack/react-router'
import { FinanceCategoriesPage } from '_/features/finance/ui/pages/finance-categories-page'

export const Route = createFileRoute('/_authenticated/finance/categories')({
	staticData: { title: 'finance_categories_title' },
	component: FinanceCategoriesPage,
})
